import { ConfigProvider, Layout, Skeleton } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { IState } from '../graphql/types';

import FeedPlayer from './FeedPlayer';
import AI from './FeedPlayer/AI';
import { GiideRouteParams, giideTabState } from '../types';
import useGiide from '../hooks/useQuery/useGiide';
import useRecording from '../hooks/useQuery/useRecording';
import { useParams } from 'react-router';
import { colors, feedViewTheme } from '../theme';

const GiideSideMenuRight: React.FC<{
  hasChapters: boolean;
  loading: boolean;
}> = ({ hasChapters, loading }) => {
  const tabState = useSelector<IState, giideTabState>(state => state.tabState);

  const { id } = useParams<GiideRouteParams>();

  const { openedStep } = useGiide(id);

  const { recording } = useRecording(openedStep?.id);

  return (
    <ConfigProvider theme={feedViewTheme}>
      <Layout.Sider
        style={{
          // borderLeft: '1px solid ' + colors.white3,
          backgroundColor: colors.white1,
          height: '100%',
          overflow: 'hidden',
        }}
        className={`${tabState === 'published' ? 'giideSideMenuHidden' : ''}`}
        width="385px"
        theme={'light'}
      >
        <Skeleton
          active
          loading={loading}
          style={{ margin: '8px auto', width: 'calc(100% - 16px)' }}
        >
          {tabState === 'audio' ? (
            // <Tabs
            //   centered={true}
            //   className="right-side-menu-tabs"
            //   items={tabs}
            // />
            <div>
              <AI />
            </div>
          ) : (
            // This is all here to prevent the side menu appearing before the transcript view appears
            openedStep &&
            recording &&
            !recording.deleted &&
            recording.transcriptResults && (
              <FeedPlayer hasChapters={hasChapters} />
            )
          )}
        </Skeleton>
      </Layout.Sider>
    </ConfigProvider>
  );
};

export default GiideSideMenuRight;
